import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react'

export const CustomWarningDelete = ({ title, text, action, btnName  }) => {

    const classes = useStyles();

    return (
        <div className={ classes.main }>
            <div className={ classes.body }>
                <h2>{ title }</h2>
                <span className={ classes.text }>
                    { text }
                </span>
            </div>

            <div className={ classes.footer }>
                <div className={ classes.containerButtons }>
                    <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={ action }
                        className={ classes.successButton }
                    >
                        { btnName }
                    </Button>
                </div>
            </div>
        </div>
    );
}

CustomWarningDelete.defaultProps = {
    title: '¡Atención!',
    text: '¿Está seguro que desea eliminar el registro?',
    action: () => false,
    btnName: 'Eliminar'
}

const useStyles = makeStyles({
    main: {
        position: 'relative', 
        width: 480, 
        height: 180
    },
    body: {
        height: "100%", 
        padding: 20
    },
    text: {
        position: "relative", 
        fontWeight: '500',
        top: 10
    },
    footer: {
        width: "100%",
        height: 60,
        position: "absolute",
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        background: "#fff",
        zIndex: 9,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
    },
    containerButtons: {
        display: "flex",
        gap: 8,
        paddingRight: 20,
        paddingBottom: 10
    },
    successButton: {
        color: '#fff !important',
        background: '#d32f2f !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#d32f2f !important',
            background: '#fff !important',
            borderColor: '#d32f2f !important'
        }
    }
});